/* istanbul ignore file */
export * from './EcoFriendlyDelivery';
